<template>
  <v-footer class="footer">
    <div class="container">
      <img
        class="geeksalon"
        :src="require('@/assets/geeksalon.png')"
        alt="geeksalon"
      />
      <a class="guide" href="https://geek-salon.com/" target="_blank"
        >公式webサイトはこちら ></a
      >
      <div class="sns">
        <a
          :href="sns.link"
          v-for="(sns, index) in services"
          :key="index"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img class="icon" :src="sns.img" :alt="sns.name" />
        </a>
      </div>
      <p class="copy_right">&copy; 2020 GeekSalon inc.</p>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",

  data: () => ({
    services: [
      {
        name: "facebook",
        link: "https://www.facebook.com/geeksalon/",
        img: require("./images/facebook.png"),
      },
      {
        name: "instagram",
        link: "https://www.instagram.com/geeksalon/?hl=ja",
        img: require("./images/instagram.png"),
      },
      {
        name: "twitter",
        link: "https://twitter.com/geek_salon",
        img: require("./images/twitter.png"),
      },
      {
        name: "youtube",
        link: "https://www.youtube.com/channel/UCCq27jgsda3YYhbL7Z_qvZg",
        img: require("./images/youtube.png"),
      },
    ],
  }),
}
</script>

<style lang="scss">
.footer {
  background: linear-gradient(270deg, #ffac59, #ffc859);
  margin-top: 96px;

  .container {
    margin: 80px auto 0;
    font-family: "GenJyuuGothic";
    text-align: center;

    .geeksalon {
      display: block;
      width: 200px;
      margin: 0 auto 16px;
    }

    .guide,
    .copy_right {
      color: #fff;
      text-decoration: none;
      font-size: 12px;
    }

    .sns {
      display: flex;
      justify-content: center;
      margin: 40px auto 80px;
      list-style: none;

      .icon {
        width: 30px;
        margin: 0 20px;
      }
    }
  }
}
</style>
